import * as yup from 'yup';
import { TFunction } from 'i18next';
import { ITreeItem } from '~/utils/interface/common';
import { EMPTY_STRING } from '~/utils/constants/common';
import { IProductGroup } from '~/utils/interface/quotes';

export const treeItemSchema = (t: TFunction): yup.ObjectSchema<ITreeItem<IProductGroup>> =>
  yup.object().shape({
    id: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    level: yup.number().required(t('common_validate_field_required', { ns: 'common/base' })),
    screenId: yup.string().optional(),
    type: yup.string().optional(),
    parentId: yup.string().optional(),
    order: yup.number().optional(),
    canHaveChildren: yup.boolean().optional(),
    addOn: yup.boolean().optional(),
    data: yup
      .object()
      .shape({
        groupId: yup.number().optional(),

        // name: yup.string().when('groupId', {
        //   is: (val: number | undefined) => val !== undefined,
        //   then: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
        //   otherwise: yup.string().optional(),
        // }),
        isMakeDefault: yup.boolean().optional(),
        inventoryId: yup.string().optional(),
        laborCost: yup.string().optional(),
        duration: yup.number().optional(),
        additionalHours: yup.number().optional(),
        indexGroup: yup.number().optional(),
        isRequired: yup.boolean().optional(),
        isShowPrice: yup.boolean().optional(),
        quantity: yup
          .number()
          .transform((_value, originalValue) => {
            if (originalValue === null || originalValue === undefined) return 0;
            if (typeof originalValue === 'string' && originalValue.trim() === EMPTY_STRING) return 0;
            const parsed = Number(originalValue);
            return Number.isNaN(parsed) ? 0 : parsed;
          })
          .when('isRequired', {
            is: true,
            then: (schema) => schema.moreThan(0, t('common_validate_field_required', { ns: 'common/base' })),
            otherwise: (schema) => schema.min(0).optional(),
          }),
        note: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
        price: yup.number().required(t('common_validate_field_required', { ns: 'common/base' })),
        discountType: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
        discountRate: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
        total: yup.number().required(t('common_validate_field_required', { ns: 'common/base' })),
      })
      .required(t('common_validate_field_required', { ns: 'common/base' })),
    children: yup.lazy(() => yup.array().of(treeItemSchema(t))).optional(),
    parent: treeItemParentSchema.optional(),
  });

const treeItemParentSchema = yup.object({
  id: yup.string().required(),
  level: yup.number().required(),
  parentId: yup.string().optional(),
  type: yup.string().optional(),
});
